import dialogType from '../../../../display/dialogs/dialogType'

import api from '../../../../configs/api'

const observationType =
{
    title : 'Types d\'observation' ,
    edit  :
    {
        agree       : 'Enregistrer' ,
        description : 'Sélectionner des types d\'observation dans la liste ci-dessous.',
        disagree    : 'Annuler' ,
        fail        : 'Veuillez corriger les erreurs ci-dessous!' ,
        loading     : 'Chargement en cours...',
        refresh     : 'Charger',
        success     : 'Mise à jour réussie!' ,
        title       : 'Types d\'observation' ,
        uri         : api.thesaurus.observations_types,
        type        : dialogType.THESAURUS_CHECKER
    },
    tooltips :
    {
        add    : "Ajouter" ,
        edit   : "Modifier" ,
        remove : "Supprimer"
    }
};

export default observationType ;